module.exports = __webpack_public_path__ + "static/media/target1_0.763d8624.png";